import { SAVE_STATUS, SAVING_DURATION } from '@/common/constants';
import PpButton from '@/components/Buttons/Button';
import { useSavingStatus } from '@/views/CreateBook/composables';
import { mapMutations } from 'vuex';
import SavingIndicator from './SavingIndicator';
import { MUTATES as PRINT_MUTATES } from '@/store/modules/print/const';
import { MUTATES as APP_MUTATES } from '@/store/modules/app/const';

export default {
  setup() {
    const { savingStatus } = useSavingStatus();

    return { savingStatus };
  },
  components: {
    PpButton,
    SavingIndicator
  },
  props: {
    nameEditor: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      message: 'Autosaving...',
      overlay: false
    };
  },
  watch: {
    overlay(val) {
      if (val && this.savingStatus === SAVE_STATUS.END)
        setTimeout(() => {
          this.overlay = false;
        }, SAVING_DURATION);
    }
  },
  methods: {
    ...mapMutations({
      setSafeMargin: PRINT_MUTATES.SET_SAFE_MARGIN,
      setTrimLineBleed: PRINT_MUTATES.SET_TRIM_LINE_BLEED,
      setShowGrid: APP_MUTATES.SET_SHOW_GRID
    }),
    /**
     * Click save and emit save button
     */
    onClickSave() {
      this.setTrimLineBleed({ hideTrimLineBleed: false });
      this.setSafeMargin({ hideSafeMargin: false });
      this.setShowGrid({ showGrid: false });
      this.message = 'Saving....';
      this.overlay = true;
      this.$emit('onClickSave');
    }
  }
};
